// @External Dependencies
import axios from 'axios'

// @Dependencies
import { apiURL } from '../../../../Config/constants'
import { getToken, axiosError } from '../../../Services'

/**
 * Busca todas las Posiciones Ejecutivas ordenadas por nombre Ascendente
 *
 * @example
 * ```js
 *    const response = await getExecutivePositions()
 * ```
 * @returns Retorna una Lista con las Posiciones Ejecutivas (id, name)
 */
const getExecutivePositions = () => {
  const requestId = 'getExecutivePositions'
  return async dispatch => {
    getToken()

    const query = `
      query allExecutivePositions{
        allExecutivePositions(
          orderBy: name_ASC
        ){
          name
          id
        }
      }
    `

    return axios
      .post(`${apiURL}/graphql`, { query }, { requestId })
      .then(response => {
        const { allExecutivePositions } = response.data.data
        if (response.status === 200 && allExecutivePositions) {
          return {
            data: allExecutivePositions,
            status: {
              success: true,
              detail: 'Petición exitosa'
            }
          }
        } else {
          return {
            data: [],
            status: {
              success: false,
              detail: 'Error al buscar las posiciones ejecutivas.'
            }
          }
        }
      })
      .catch(err => axiosError(err, requestId, dispatch))
  }
}

export default getExecutivePositions
